import type { AutoCandidate, SequenceObjective, SequenceOrderResult } from "@opus-dt/shared-types";

// Tipos de domínio do sequenciamento da fila, 1:1 com `useSequenceBatch`.

export type { SequenceObjective, SequenceOrderResult };

/** Linha do ranking: um candidato de sequência com a métrica do objetivo e o delta vs. a fila atual. */
export interface SequenceRankingRow {
  simulationId: string;
  label: string;
  isBaseline: boolean;
  isWinner: boolean;
  rank: number | null;
  status: AutoCandidate["status"];
  /** Todas as ordens couberam no horizonte simulado. */
  completed: boolean;
  /** Σ atraso das ordens com prazo (min); null quando a fila não coube. */
  latenessMin: number | null;
  /** Σ setup pago nas trocas (min); null quando a fila não coube. */
  setupMin: number | null;
  /** Fim da última ordem (h desde a âncora); null quando a fila não coube. */
  makespanH: number | null;
  /** Diferença da métrica do objetivo vs. baseline — negativo é melhora. */
  deltaObjective: number | null;
  orders: SequenceOrderResult[];
}

export const SEQUENCE_OBJECTIVE_OPTIONS: Array<{
  id: SequenceObjective;
  label: string;
  hint: string;
}> = [
  {
    id: "TOTAL_LATENESS",
    label: "Entregar no prazo",
    hint: "minimiza o atraso somado das ordens com prazo",
  },
  {
    id: "TOTAL_SETUP",
    label: "Reduzir trocas",
    hint: "minimiza o tempo total de preparação entre produtos",
  },
  {
    id: "MAKESPAN",
    label: "Terminar antes",
    hint: "minimiza o instante em que a última ordem fica pronta",
  },
];
